import { Boton } from './ui';
import { useInstalar } from './instalar';

/** Misma invitación de Rankealo: abrir desde el ícono evita la barra del navegador. */
export function InstalarApp() {
  const instalar = useInstalar();
  if (instalar.tipo === 'oculto') return null;

  return <>
    <div aria-hidden="true" className="h-64" />
    <aside aria-label="Instalar EnCancha" className="fixed inset-x-0 bottom-[calc(1rem+env(safe-area-inset-bottom))] z-40 mx-auto max-w-lg px-3">
      <div className="rounded-2xl border border-(--color-acento) bg-(--color-panel) p-4 shadow-2xl">
        <p className="font-semibold">Instalá EnCancha en el celular</p>
        {instalar.tipo === 'android' ? <>
          <p className="mt-1 text-sm text-(--color-apagado)">Abrila desde su ícono para usarla sin la barra de dirección.</p>
          <div className="mt-3 flex gap-2">
            <Boton ancho chico onClick={() => void instalar.instalar()}>Instalar</Boton>
            <Boton tipo="secundario" chico onClick={instalar.posponer}>Ahora no</Boton>
          </div>
        </> : <>
          <p className="mt-1 text-sm text-(--color-apagado)">En Safari, tocá <strong className="text-(--color-texto)">Compartir</strong> y después <strong className="text-(--color-texto)">Agregar a inicio</strong>. Abrila desde el ícono para usarla sin la barra de dirección.</p>
          <p className="mt-2 text-xs text-(--color-apagado)">Al abrirla desde el ícono, puede pedirte el PIN de nuevo.</p>
          <div className="mt-3"><Boton tipo="secundario" chico ancho onClick={instalar.posponer}>Entendido</Boton></div>
        </>}
      </div>
    </aside>
  </>;
}
